const { addAnalyticsListeners } = require('./analytics/addAnalyticsListeners');
const { pushToDataLayer } = require('./analytics/pushToDataLayer');

window.HMSAnalytics = class HMSAnalytics {
  static pushToDataLayer(...params) {
    pushToDataLayer(...params)
  }

  constructor() {
    this.init();
  }

  init() {
    addAnalyticsListeners();
  }
}